if (!customElements.get('footer-details')) {
    class FooterDetails extends AccordionDetails {
        constructor() {
            super();
        }

        connectedCallback() {
            this.openDefault = this.dataset.openDefault === 'true';

            if (FoxTheme.config.mqlTablet) {
                if (!this.openDefault) this.open = false;
            }

            document.addEventListener('matchTablet', () => {
                if (!this.openDefault) {
                    this.open = false;
                } else {
                    this.open = true;
                }
            });

            document.addEventListener('unmatchTablet', () => {
                this.open = true;
            });
        }
    }
    customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

// Weglot 스위처 ID(헤더·브랜드 GNB·모바일 메뉴: 2, 푸터: 1)를 기준으로 각 슬롯에 배치
if (!window.footerWeglotPositionInitialized) {
    window.footerWeglotPositionInitialized = true;

    const setupFooterWeglotPosition = () => {
        const mediaQuery = window.matchMedia('(max-width: 1023.98px)');

        const getHeaderWeglotTarget = () => {
            if (mediaQuery.matches) {
                return document.querySelector('[data-mobile-menu-weglot]');
            }

            const vendorGnb = document.querySelector('[data-vendor-gnb]:not([hidden])');
            if (!vendorGnb) return document.querySelector('[data-header-weglot]');

            const desktopMenuPanel = vendorGnb.querySelector(
                '[data-vendor-gnb-desktop-menu-panel]'
            );
            const slotName = desktopMenuPanel && !desktopMenuPanel.hidden ? 'desktop-menu' : 'main';

            return vendorGnb.querySelector(`[data-vendor-gnb-weglot="${slotName}"]`);
        };

        const moveWeglot = () => {
            const footer = document.querySelector('.footer');
            const headerTarget = getHeaderWeglotTarget();
            if (!footer) return;

            // Weglot 관리자에서 생성한 스위처 ID로 헤더와 푸터를 명확히 구분
            const footerWeglot = document.querySelector('.weglot-container[data-switcher-id="1"]');
            const headerWeglot = document.querySelector('.weglot-container[data-switcher-id="2"]');

            const footerTarget = footer.querySelector(
                mediaQuery.matches ? '[data-footer-weglot-mobile]' : '[data-footer-weglot-desktop]'
            );
            if (
                footerTarget &&
                footerWeglot?.querySelector('.weglot_switcher') &&
                footerWeglot.parentElement !== footerTarget
            ) {
                mediaQuery.matches
                    ? footerTarget.prepend(footerWeglot)
                    : footerTarget.appendChild(footerWeglot);
            }
            if (
                headerTarget &&
                headerWeglot?.querySelector('.weglot_switcher') &&
                headerWeglot.parentElement !== headerTarget
            ) {
                headerTarget.appendChild(headerWeglot);
            }
        };

        moveWeglot();

        const contentObserver = new MutationObserver(moveWeglot);
        contentObserver.observe(document.body, { childList: true, subtree: true });

        const headerStateObserver = new MutationObserver(moveWeglot);
        const observeHeaderState = () => {
            document
                .querySelectorAll('[data-vendor-gnb], [data-vendor-gnb-desktop-menu-panel]')
                .forEach(element => {
                    headerStateObserver.observe(element, {
                        attributes: true,
                        attributeFilter: ['hidden'],
                    });
                });
        };

        observeHeaderState();
        document.addEventListener('shopify:section:load', () => {
            observeHeaderState();
            moveWeglot();
        });
        mediaQuery.addEventListener('change', moveWeglot);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupFooterWeglotPosition, { once: true });
    } else {
        setupFooterWeglotPosition();
    }
}
